import React from "react";
import { Grid, Typography , Button } from "@mui/material";
import { getOrdinalSuffix } from "../../utils/helperFunctions";
import './calendar.css'
import moment from "moment";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

const Notes = ({ notes, loading , isNotesOpen , setIsNotesOpen }) => {

  return (
    <div >
      <div style={{display:'flex', justifyContent:'space-between' , backgroundColor:'#BF1D2D'}} className="px-2">
        <div style={{marginTop:'15px'}} className="notes-header">
          {isNotesOpen == 2 ? (
            <div>
              <img src="/images/notes-icon.svg" width="24px" height="24px" />
              <p></p>
            </div>
          ) : (
            <div style={{display:'flex'}}>
              <img src="/images/notes-icon.svg" width="24px" height="24px" />
              <p style={{color:"#ffffff", marginLeft:'10px'}}>Daily Notes</p>
            </div>
          )}
        </div>
        <Button
            sx={{
              color: "#FFF",
              "&.MuiButton-root:active": { backgroundColor: "#2E3238" },
              "&.MuiButton-root:hover": { backgroundColor: "transparent" },
            }}
            className="toggle-button"
            onClick={() => setIsNotesOpen(isNotesOpen == 1 ? 2 : 1)}
            endIcon={
              isNotesOpen  == 2 ? (
                <KeyboardDoubleArrowLeftIcon style={{ fontSize: 30 }} />
              ) : (
                <KeyboardDoubleArrowRightIcon style={{ fontSize: 30 }} />
              )
            }
          ></Button>
      </div>
      {isNotesOpen == 2 ? (
        <div className = {notes.length === 0 ? 'empty-notes':'notes'} style={{border:'1px solid #cac9c9' , padding:'0px 10px' , paddingTop:'10px' , backgroundColor:'#F9FAFB'}}>
          <p>Available Notes : {notes?.length}</p>
        </div>
        ): (
        <div style={{ borderLeft: notes.length === 0 ? '0px':'2px solid #cac9c9' , 
              borderBottom: notes.length === 0 ? '0px':'2px solid #cac9c9'}} 
              className = {notes.length === 0 ? 'empty-notesopen':'notesopen'}
          >
          <Grid container padding="10px" backgroundColor="#F9FAFB">
            <Grid item xs={3}>
              <Typography color="#6E7C87">Day</Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography color="#6E7C87">Note</Typography>
            </Grid>
          </Grid>
          {!loading && notes.length === 0 ? (
            <Typography textAlign="center" marginTop="10px">{`There are no notes for this month`}</Typography>
          ) : (
            notes?.map((item, index) => {
              return (
                !loading && (
                  <Grid key={index} container borderBottom="1px solid #cac9c9"  className="p-2">
                    <Grid item xs={3}>
                    <Typography>{moment(item.Note_Date).format('ddd DD')}{getOrdinalSuffix(moment(item.Note_Date).format('DD'))}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography className="notes-overflow">{item.Note}</Typography> 
                    </Grid>
                  </Grid>
                )
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default Notes;
